import type { JSX } from "react";
import t from "../../../shared/translations";
import type { ITask, ITaskVariant } from "../query";
import { Button } from "../stylings";

interface Props {
    task: ITask;
    variant: ITaskVariant;
    invert: boolean;
}

function StartQuiz({ task, variant, invert }: Props): JSX.Element {
    const question = variant.taskQuestions.find((q) => q.quizId);
    if (!question) {
        return null;
    }
    const quizId = question.quizId;
    return (
        <form action={`/quiz/${quizId}`} method="post">
            {question.questionContent && <h4>{question.questionContent}</h4>}
            <input type="hidden" name="task_id" value={task.id} />
            <input type="hidden" name="variant_id" value={variant.id} />
            <input name="csrf_token" type="hidden" value={__CSRF_TOKEN__} />
            <div className="text-center">
                <Button type="submit" $invert={invert}>
                    {t("player.task.button-start-quiz")}
                </Button>
            </div>
        </form>
    );
}

export default StartQuiz;
